/*
 * Shopify money formatting for scripts that build prices client side.
 *
 * Shopify only renders money through Liquid's `money` filters, so anything that
 * recomputes a price in the browser has to reproduce the shop's format string
 * itself. This is that one implementation -- pass the format straight from
 * Liquid (`shop.money_format`, or `shop.money_with_currency_format` when
 * settings.currency_code_enabled is on) and the amount in cents.
 *
 * Usage:
 *   window.Theme.formatMoney(4999, element.dataset.moneyFormat)
 */
window.Theme = window.Theme || {};

if (!window.Theme.formatMoney) {
  window.Theme.formatMoney = function formatMoney(cents, moneyFormat) {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const format = moneyFormat || '${{amount}}';
    const match = format.match(placeholderRegex);
    if (!match) return format;

    const withDelimiters = (precision, thousands = ',', decimal = '.') => {
      const number = (cents / 100.0).toFixed(precision);
      const parts = number.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return parts[1] ? whole + decimal + parts[1] : whole;
    };

    let value;

    switch (match[1]) {
      case 'amount':
        value = withDelimiters(2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(0, ' ');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(2, ' ', '.');
        break;
      default:
        value = withDelimiters(2);
    }

    return format.replace(placeholderRegex, value);
  };
}
